module.exports = __webpack_public_path__ + "img/batman.0ff512cf.svg";